// extracted by mini-css-extract-plugin
export default {"DeleteLibraryAdminDialog":"DeleteLibraryAdminDialog_DeleteLibraryAdminDialog__1btNt"};